import { absolutePath } from "./absolutePath";

export const voiceMessages = {
  signedUploadUrl: () => absolutePath("voice_messages/signed_upload_url"),
  processFileUrl: () => absolutePath("voice_messages/process_file"),
};
